module.exports = __webpack_public_path__ + "static/media/score_result_3.4cb65ed7.png";